import { useMutation } from 'react-query';

import VehiclesAPI from 'api/Vehicles';
import { CalculateInstallmentPayload } from 'api/Vehicles/interfaces';
import { setModalErrorOpen } from 'app/domain/loan/slice';
import store from 'store/configureStore';

const usePostCalculateInstallment = () =>
  useMutation((payload: CalculateInstallmentPayload) =>
    VehiclesAPI.postCalculateInstallment(payload)
      .then(response => response.data)
      .catch(err => {
        store.dispatch(setModalErrorOpen());
        throw new Error(err.message);
      }),
  );

export default usePostCalculateInstallment;
